import type { ReactNode } from "react";
import { Suspense, useState } from "react";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";


type AppProviderProps = {
	children: ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: { refetchOnWindowFocus: false, cacheTime: 0 },
				},
			}),
	);

	// const [trpcClient] = useState(() =>
	// 	trpc.createClient({
	// 		links: [
	// 			httpBatchLink({
	// 				url: `${import.meta.env.VITE_PUBLIC_SECURITY_API_URL}/api/trpc`,
	// 			}),
	// 		],
	// 		transformer: transformer,
	// 	}),
	// );

	return (
		<Suspense
			fallback={
				<div className="flex h-screen w-screen items-center justify-center">
					loading ...
				</div>
			}
		>
			<Sentry.ErrorBoundary fallback={<div>Error</div>}>
				<QueryClientProvider client={queryClient}>
					{/* eslint-disable-next-line turbo/no-undeclared-env-vars */}
					{import.meta.env.MODE === "development" && <ReactQueryDevtools />}
					{children}
				</QueryClientProvider>
			</Sentry.ErrorBoundary>
		</Suspense>
	);
};
